import type { FaireProductEntity } from "../../entity_types/product";

export const p_g6hcataprv: FaireProductEntity = {
  token: "p_g6hcataprv",
  type: "product",
  name: "Not Coffee - Wholesale",
  brandToken: "b_7piiqmq04r",
  brandName: "Lake & Oak Tea Co.",
  imageUrl: "https://cdn.faire.com/fastly/0dbc7f703336604b30040f58388cd9e37308de36d490a3a874e9b267dac69ca6.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/96157bae83b58d2db056bfe2e4c27345bedab97455cf39036a79ca784d06225e.png",
    "https://cdn.faire.com/fastly/9013f8e86cb3c5fd2627c64554656246563e9764e72f1e162e582eabd7cfe85a.jpeg"
  ],
  priceDollars: 9.8,
  description: "SUPERFOOD TEA BLEND\n\nDear coffee, we love you for your intoxicating aroma and bold and bitter flavour. Jitters, insomnia and tummy aches? No thanks! \n\nThis herbal revelation brings the glorious richness and ritual of your morning brew, but leaves the rest. Formulated with power plants like detox-worthy dandelion root and stress-busting ashwagandha, it’s a satisfying, feel-good fix without the flop.\n\n100% ORGANIC - ADAPTOGENIC - NUTRITIONIST FORMULATED \n\nHow to Enjoy:\n\n * Steep tea in 1 cup of 98° water for 4-6 minutes. \n * Try me with a splash of milk and honey (or however you enjoy your coffee!) \n * Tea Latte: Steep tea double strength and top with frothed milk, vanilla and sweetener. \nWhen to Steep:\n\n\n * During your morning ritual \n * With your breakfast in the morning \n * As a 2pm pick-me-up \n * Instead of your afternoon coffee \n * As a soothing after-dinner treat \nCaffeine-free\n",
  tags: [],
  msrpDollars: 15.5,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-09-07T19:04:42.731Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
